/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ChecklistIcon = createIcon("ChecklistIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "45",
    height: "47",
    viewBox: "0 0 45 47",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M4 10 .666 6.666a1 1 0 01-.04-1.37l.143-.163a1 1 0 011.48-.017L4 7l5.793-5.793a1 1 0 011.414 0l.086.086a1 1 0 010 1.414L4 10Zm0 18a2 2 0 100-4 2 2 0 000 4Zm0 19a2 2 0 100-4 2 2 0 000 4ZM44 6H16a1 1 0 100 2h28a1 1 0 100-2Zm0 19H16a1 1 0 100 2h28a1 1 0 100-2Zm0 19H16a1 1 0 100 2h28a1 1 0 100-2Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});